import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CloseIcon from "@mui/icons-material/Close";
import ScheduleIcon from "@mui/icons-material/Schedule";

const SUPPORT_PHONE_DISPLAY = "054-318-1713";
// Israeli mobile in international format (drop leading 0, prefix 972) for wa.me
const SUPPORT_WHATSAPP_URL = "https://wa.me/972543181713";

const checklist = [
  "שם המוסד",
  "צילום מסך של התקלה",
  "שם התלמיד ומספר הטלפון שלו (אם הפנייה קשורה לתלמיד מסוים)",
];

type Props = {
  open: boolean;
  onClose: () => void;
};

const SupportDialog: React.FC<Props> = ({ open, onClose }) => {
  const theme = useTheme();
  const whatsappGreen = "#25D366";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        תמיכה
        <IconButton
          onClick={onClose}
          sx={{ color: "text.secondary", mx: -1 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2.5}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              p: 1.5,
              borderRadius: 1.5,
              bgcolor: theme.palette.action.hover,
            }}
          >
            <ScheduleIcon color="action" />
            <Box>
              <Typography variant="body2" color="text.secondary">
                שעות הפעילות
              </Typography>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                ימים ראשון–חמישי, 9:00–17:00
              </Typography>
            </Box>
          </Box>

          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body1">
              צוות התמיכה שלנו זמין עבורכם בוואטסאפ במספר:
            </Typography>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, direction: "ltr", mt: 0.5 }}
            >
              {SUPPORT_PHONE_DISPLAY}
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
              כדי שנוכל לעזור לכם במהירות, אנא צרפו לפנייה:
            </Typography>
            <Stack component="ul" sx={{ m: 0, pr: 2.5, gap: 0.5 }}>
              {checklist.map((item) => (
                <Typography
                  key={item}
                  component="li"
                  variant="body2"
                  color="text.secondary"
                >
                  {item}
                </Typography>
              ))}
            </Stack>
          </Box>

          <Button
            variant="contained"
            size="large"
            fullWidth
            startIcon={<WhatsAppIcon />}
            href={SUPPORT_WHATSAPP_URL}
            target="_blank"
            rel="noopener"
            sx={{
              bgcolor: whatsappGreen,
              "&:hover": { bgcolor: "#1da851" },
              py: 1.25,
            }}
          >
            פתיחת צ'אט בוואטסאפ
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SupportDialog;
